import 'zone.js/dist/zone-error';  // Included with Angular CLI.
import { LogLevel } from 'msal';
import { version, adB2c } from './common.settings';

export const environment = {
  production: JSON.parse('true'),   // trick to parse boolean string to boolean
  baseUrl: 'https://admin.sta.kazi.co/',
  msalLogLevel: LogLevel.Error,
  version,
  googleTagManagerId: '',
  adB2c,

  api: {
    subscriptionKey: 'kazi-admin-portal',
    clientId: 'kazi-admin-portal',
    identifyingUrl: 'https://api.kazi.be/identifying/v2',
    taggingUrl: 'https://api.kazi.be/tagging/v2',
    administratorUrl: 'https://api.kazi.be/admin/v2',
    pageSize: parseInt('30', 10)
  },

  sentry: {
    enabled: JSON.parse('false'),
    dsn: 'https://52354eab8e214b4f96a89f76d729eab6@sentry.io/1425679'
  }
};
